'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Compass, Star, MessageCircle, User, Heart } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const NAV_ITEMS = [
  { id: 'nav-discover', label: 'Discover', icon: Compass, href: '/discovery-feed' },
  { id: 'nav-connections', label: 'Matches', icon: Heart, href: '/connections' },
  { id: 'nav-chart', label: 'My Chart', icon: Star, href: '/my-chart' },
  { id: 'nav-chats', label: 'Chats', icon: MessageCircle, href: '/cosmic-chat' },
  { id: 'nav-profile', label: 'Profile', icon: User, href: '/profile' },
];

export default function BottomNav() {
  const pathname = usePathname();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass-strong border-t border-purple-mid/30">
      <div className="flex items-center justify-around px-2 py-2 max-w-lg mx-auto">
        {NAV_ITEMS?.map((item) => {
          const Icon = item?.icon;
          const isActive =
            item?.href !== '#' &&
            (pathname === item?.href ||
              (item?.href === '/discovery-feed' && pathname === '/'));
          return (
            <Link
              key={item?.id}
              href={item?.href}
              className={`flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-all duration-200 ${
                isActive
                  ? 'text-accent' :'text-muted-foreground hover:text-silver'
              }`}
            >
              <div className={`relative ${isActive ? 'glow-text-gold' : ''}`}>
                <Icon
                  size={22}
                  strokeWidth={isActive ? 2.5 : 1.8}
                  className={isActive ? 'text-accent' : ''}
                />
                {isActive && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-accent" />
                )}
              </div>
              <span
                className={`text-[10px] font-medium tracking-wide ${
                  isActive ? 'text-accent' : 'text-muted-foreground'
                }`}
              >
                {item?.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}